import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {SettingService} from "./setting.service";
import {SchoolProgramModel} from "../models/school-program-model";
import {SchoolProgramCategoryModel} from "../models/school-program-category-model";
import {SchoolProgramActivityModel} from "../models/school-program-activity-model";
import {RuleModel} from "../models/rule.model";

@Injectable()
export class SchoolProgramService {
    constructor(private settings: SettingService,
                private http: HttpClient) {
    }
    api = 'school-program-http/api/v1';
    
    // API Untuk School Program
    getSchoolProgram(param: any): Observable<SchoolProgramModel> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/list';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/list';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    createSchoolProgram(param: Object): Observable<SchoolProgramModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/create';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/create';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    updateSchoolProgram(param: Object): Observable<SchoolProgramModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/update';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    bulkSaveSchoolProgram(param: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/create-bulk';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/create-bulk';

        return this.http.post<any>(requestUrl, param, this.settings.httpOptionWithSession());
    }

    deleteSchoolProgram(id: number): Observable<SchoolProgramModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + `/school-program/${id}`;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + `/school-program/${id}`;

        return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
    }


    // API Untuk School Program Category
    getSchoolProgramCategory(param: any): Observable<SchoolProgramCategoryModel> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-category/list';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    createSchoolProgramCategory(param: Object): Observable<SchoolProgramCategoryModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-category/create';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-category/create';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    updateSchoolProgramCategory(param: Object): Observable<SchoolProgramCategoryModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-category/update';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

   deleteSchoolProgramCategory(id: number): Observable<SchoolProgramCategoryModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + `/school-program-category/${id}`;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + `/school-program-category/${id}`;

        return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    // API Untuk School Program Activity
    getSchoolProgramActivity(param: any): Observable<SchoolProgramActivityModel> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/list';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/list';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }
    getSchoolProgramActivityStudent(param: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/dashboard-student/activity-list';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/dashboard-student/activity-list';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }
    approveSchoolProgramActivity(param: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/approve';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/approve';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    createSchoolProgramActivity(param: Object): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/create';
        // const requestUrl = "http://localhost:3075" + '/' + this.api + '/school-program-activity/create';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    updateSchoolProgramActivity(param: Object): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/update';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/update';

        return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
    }

    bulkSaveSchoolProgramActivity(param: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/create-bulk';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/create-bulk';

        return this.http.post<any>(requestUrl, param, this.settings.httpOptionWithSession());
    }

    deleteSchoolProgramActivity(id: number): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + `/school-program-activity/${id}`;

        return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
    }
    getSchoolProgramActivityDetail(id: number): Observable<SchoolProgramActivityModel> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + `/school-program-activity/${id}`;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + `/school-program-activity/${id}`;

        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }
    
    getSchoolProgramDetailFromActivity(activityId: number): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + `/school-program/activity/${activityId}`;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + `/school-program/activity/${activityId}`;

        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    // API Other
    getSchoolProgramParticipantChart(param: any): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api +
            `/school-program/participation-chart?academic_year=${param.academic_year}&school_location_id=${param.school_location_id}&school_program_id=${param.school_program_id}`;
        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    getSchoolProgramActivityInformation(id: any): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api +
            `/school-program/information?school_program_activity_id=${id}`;
        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    getSchoolProgramTotalActivities(param: any): Observable<SchoolProgramModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/total-activities';

        return this.http.post<any>(requestUrl,param, this.settings.httpOptionWithSession());
    }

    getSchoolProgramCategoryTotalActivities(param: any): Observable<SchoolProgramCategoryModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-category/total-activities';

        return this.http.post<any>(requestUrl,param, this.settings.httpOptionWithSession());
    }

    getActivityParticipantList(param: any): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/participant-list';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/participant-list';

        return this.http.post<any>(requestUrl,param, this.settings.httpOptionWithSession());
    }

    getUnregisteredStudentList(param: any): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/unregistered-student-list';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/unregistered-student-list';

        return this.http.post<any>(requestUrl,param, this.settings.httpOptionWithSession());
    }
    saveActivityParticipant(param: any): Observable<SchoolProgramActivityModel[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/participant-create';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/participant-create';

        return this.http.post<any>(requestUrl, param, this.settings.httpOptionWithSession());
    }

    getSupervisorList(id: number): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/supervisor-list/' + id;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/supervisor-list/' + id;

        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    getCoachList(id: number): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/coach-list/' + id;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/coach-list/' + id;

        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    getActivityParticipantApprover(school_location_id: number, yearLevel: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/approver-list/' + school_location_id;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/approver-list/' + school_location_id;

        return this.http.post<any>(requestUrl, yearLevel, this.settings.httpOptionWithSession());
    }

    getRoleList(): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/rolelist';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/rolelist';

        return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    getUserList(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/userlist';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/userlist';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    getActivityParticipantReport(activityId: number): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/activity-participant-report/' + activityId;
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/activity-participant-report/' + activityId;

        return this.http.get<Blob>(requestUrl, {
            ...this.settings.httpOptionWithSession(),
            responseType: 'blob' as 'json',
        });
    }

    getUnregisteredReport(params: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/activity-unregistered-report';
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/activity-unregistered-report';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    getRegisteredReport(params: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/activity-registered-report';
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/activity-registered-report';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    exportUnregisteredReport(params: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/activity-unregistered-report/export';
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/activity-unregistered-report/export';

        return this.http.post(requestUrl, params, {
            ...this.settings.httpOptionWithSession(),
            responseType: 'blob'
        });
    }

    exportRegisteredReport(params: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/activity-registered-report/export';
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/activity-registered-report/export';

        return this.http.post(requestUrl, params, {
            ...this.settings.httpOptionWithSession(),
            responseType: 'blob'
        });
    }

    exportActivityToExcel(param: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/export';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program-activity/export';

        return this.http.post(requestUrl, param, {
            ...this.settings.httpOptionWithSession(),
            responseType: 'blob'
        });
    }

    copyRegisteredReport(params: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program-activity/participant/copy-to-period';
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program-activity/participant/copy-to-period';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    getSupervisorLocationAccess(params: any): Observable<any> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/supervisor/location';
        // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/supervisor/location';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    } 
}
